<template>
	<!-- @vue-ignore -->
	<MsAjaxTemplate
		ref="tmpl"
		template-name="entries"
		:get-template-data="getTemplateData"
		:ready-dependencies="['init-entries']"
	/>
</template>

<script lang="ts">
	import type { PropType } from 'vue';
	import { computed, defineComponent } from 'vue';
	import MsAjaxTemplate from './utils/MsAjaxTemplate';
	import type { Token } from 'src/components/form-controls/tokenUtils';

	export default defineComponent({
		components: {
			MsAjaxTemplate
		},
		props: {
			isLimitedAccess: {
				type: Boolean,
				default: false
			},
			isGuest: {
				type: Boolean,
				default: false
			},
			canManageEntries: {
				type: Boolean,
				default: false
			},
			canManageForm: {
				type: Boolean,
				default: false
			},
			currentViewEntryCount: {
				type: Number as PropType<number | null>,
				default: 0
			},
			showNewEntryButton: {
				type: Boolean,
				default: false
			},
			newEntryButtonText: {
				type: String,
				default: 'New Entry'
			},
			isAssignedView: {
				type: Boolean,
				default: false
			},
			disableUnreadEntryTracking: {
				type: Boolean,
				default: false
			},
			tokens: {
				type: Array as PropType<Token[]>,
				default: () => []
			},
			formInfo: {
				type: Object,
				default: () => {}
			}
		},
		setup(props) {
			const getTemplateData = () => {
				return {
					isLimitedAccess: computed(() => props.isLimitedAccess),
					canManageEntries: computed(() => props.canManageEntries),
					canManageForm: computed(() => props.canManageForm),
					currentViewEntryCount: computed(() => props.currentViewEntryCount),
					showNewEntryButton: computed(() => props.showNewEntryButton),
					newEntryButtonText: computed(() => props.newEntryButtonText),
					isAssignedView: computed(() => props.isAssignedView),
					isGuest: computed(() => props.isGuest),
					disableUnreadEntryTracking: computed(() => props.disableUnreadEntryTracking),
					tokens: computed(() => props.tokens),
					formInfo: computed(() => props.formInfo)
				};
			};
			return {
				getTemplateData
			};
		}
	});
</script>
